import { WalletClient, createWalletClient, custom } from 'viem'
import { LocalAccount } from 'viem/accounts'
import { arbitrum, avalanche, mainnet, base, bsc } from 'viem/chains'

export const getWalletClient = (chainId: number): WalletClient | null => {
  if (!window.ethereum) return null
  switch (chainId) {
    default:
    case mainnet.id:
      return createWalletClient({
        chain: mainnet,
        transport: custom(window.ethereum),
      }) as WalletClient
    case avalanche.id:
      return createWalletClient({
        chain: avalanche,
        transport: custom(window.ethereum),
      }) as WalletClient
    case arbitrum.id:
      return createWalletClient({
        chain: arbitrum,
        transport: custom(window.ethereum),
      }) as WalletClient

    case base.id:
      return createWalletClient({
        chain: base,
        transport: custom(window.ethereum),
      }) as WalletClient

    case bsc.id:
      return createWalletClient({
        chain: bsc,
        transport: custom(window.ethereum),
      }) as WalletClient
  }
}

//INFO: how to use wallet client
// import setupChains from 'services/wallet/chains'
// import { getNetwork } from 'services/wallet/network'
// const { walletClients } = setupChains()
// const network = getNetwork()
// const client = walletClients[network].extend(publicActions) // use

// JSON-RPC Account
export const getAccount = async (
  client: WalletClient,
): Promise<LocalAccount<string, `0x${string}`> | `0x${string}`> => {
  if (client?.account?.type === 'local') {
    return client.account
  }
  const [acc] = await client.getAddresses()

  return acc
}
